import React from "react";
import Langing from "./Langing";

function App() {
  return (
    <Langing />
  );
}

export default App;
